import { g as getTimeOptions } from './formatTime-BfS0XKKR.js';
import { g as getFormatDateTimeToParts } from './formatDateToParts-CfOqq_kj.js';

/**
 * @param {Date} date The date to format.
 * @param {string} locale A string with a BCP 47 language tag, or an array of such strings.
 * @param {string} timezone The time zone to use (e.g. America/New_York).
 * The default is the runtime's default time zone.
 */
const formatTimeToParts = getFormatDateTimeToParts(getTimeOptions);

export { formatTimeToParts as f };
//# sourceMappingURL=formatTimeToParts-DZcuirX9.js.map
